// ---------- Gallery thumbnail → main image swap ----------
// Delegated, so all gallery instances on the page work via one handler.
// Clicking a thumbnail:
//   1. Updates main image src + srcset + alt
//   2. Flips the --active class
//   3. Updates aria-pressed for screen readers
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('[data-s2t-ph-thumb]');
  if (!thumb) return;

  var gallery = thumb.closest('.s2t-product-hero-rtp__gallery');
  if (!gallery) return;

  var main = gallery.querySelector('[data-s2t-ph-main]');
  if (!main) return;

  var full = thumb.getAttribute('data-full');
  var srcset = thumb.getAttribute('data-srcset');
  var alt = thumb.getAttribute('data-alt');

  if (full) main.setAttribute('src', full);
  if (srcset) main.setAttribute('srcset', srcset);
  if (alt) main.setAttribute('alt', alt);

  // Flip --active state
  var allThumbs = gallery.querySelectorAll('[data-s2t-ph-thumb]');
  for (var i = 0; i < allThumbs.length; i++) {
    var t = allThumbs[i];
    var isActive = (t === thumb);
    t.classList.toggle('s2t-product-hero-rtp__thumb--active', isActive);
    t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }
});

// ---------- Countdown timer ----------
// Always counts down to the NEXT BUSINESS DAY's cutoff (configurable per
// section). Weekend skip: if tomorrow is Sat/Sun, target rolls forward to
// Monday. Timezone math handled via Intl.DateTimeFormat (DST-safe).
//
// Display format:
//   ≥ 24h   → "Xd Yh"
//   1h-24h  → "Hh Mm"
//   < 1h    → "Mm"
//
// Template placeholders the merchant can use:
//   {time}  → "Xh Ym" or "Xd Yh" or "Xm"
//   {day}   → "Monday" / "Tuesday" / etc. (cutoff day name in the configured TZ)
//   {date}  → e.g. "May 20"
(function () {
  var nodes = document.querySelectorAll('[data-s2t-ph-countdown]');
  if (!nodes.length) return;

  function getNextDispatchTarget(hour, minute, timezone, skipWeekends) {
    var now = new Date();

    // 1. Today's Y-M-D in target TZ (ISO via sv-SE locale)
    var dateFmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
    var todayParts = dateFmt.format(now).split('-').map(Number);

    // 2. Tomorrow as a local Date (day-of-week is timezone-agnostic
    //    because a calendar date IS a calendar date).
    var d = new Date(todayParts[0], todayParts[1] - 1, todayParts[2] + 1);

    // 3. Weekend skip
    if (skipWeekends) {
      var dow = d.getDay(); // 0=Sun .. 6=Sat
      if (dow === 6) d.setDate(d.getDate() + 2);      // Sat → Mon
      else if (dow === 0) d.setDate(d.getDate() + 1); // Sun → Mon
    }

    // 4. Build target = "y-m-d hour:minute" in the configured TZ as UTC ms.
    //    Trick: construct a UTC timestamp with the target wall-clock values,
    //    then ask Intl what that UTC moment is in the TZ. The difference
    //    tells us how much to shift to hit the desired wall-clock in TZ.
    var utcGuess = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), hour, minute, 0);
    var checkFmt = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var actualParts = checkFmt.format(new Date(utcGuess)).split(':').map(Number);
    var wanted = hour * 60 + minute;
    var got = actualParts[0] * 60 + actualParts[1];
    var diff = wanted - got;
    if (diff > 12 * 60) diff -= 24 * 60;
    if (diff < -12 * 60) diff += 24 * 60;
    return new Date(utcGuess + diff * 60 * 1000);
  }

  function formatRemaining(ms) {
    if (ms <= 0) return '0m';
    var totalMinutes = Math.floor(ms / 60000);
    var days = Math.floor(totalMinutes / (24 * 60));
    var hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    var minutes = totalMinutes % 60;
    if (days > 0) return days + 'd ' + hours + 'h';
    if (hours > 0) return hours + 'h ' + minutes + 'm';
    return minutes + 'm';
  }

  function render(node, target, template, timezone) {
    var remaining = target.getTime() - Date.now();
    if (remaining <= 0) return null; // signal that target needs recompute

    var dayFmt = new Intl.DateTimeFormat('en-US', { timeZone: timezone, weekday: 'long' });
    var dateFmt = new Intl.DateTimeFormat('en-US', { timeZone: timezone, month: 'short', day: 'numeric' });

    var text = template
      .replace('{time}', '__TIME__')
      .replace('{day}', dayFmt.format(target))
      .replace('{date}', dateFmt.format(target));

    // Inject the time as a styled <span> so CSS can highlight it
    // independently of the surrounding text.
    var timeSpan = '<span data-s2t-ph-countdown-time>' + formatRemaining(remaining) + '</span>';
    var html = text.replace('__TIME__', timeSpan);

    var slot = node.querySelector('[data-s2t-ph-countdown-text]');
    if (slot) slot.innerHTML = html;
    return target;
  }

  nodes.forEach(function (node) {
    var hour = parseInt(node.getAttribute('data-cutoff-hour'), 10);
    var minute = parseInt(node.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(hour)) hour = 12;
    if (isNaN(minute)) minute = 0;
    var tz = node.getAttribute('data-cutoff-timezone') || 'America/New_York';
    var skipWeekends = node.getAttribute('data-skip-weekends') !== 'false';
    var template = node.getAttribute('data-template') || 'Order in {time} for {day} dispatch!';

    var target = getNextDispatchTarget(hour, minute, tz, skipWeekends);

    function tick() {
      var result = render(node, target, template, tz);
      if (result === null) {
        // Past the cutoff while the page was open — recompute
        target = getNextDispatchTarget(hour, minute, tz, skipWeekends);
        render(node, target, template, tz);
      }
    }

    tick();
    // Update every 60 seconds. setInterval is fine here — visible drift
    // is sub-second, negligible against an hours-long countdown.
    setInterval(tick, 60000);
  });
})();

// ---------- Multi-variant qty-per-size grid + Add to Cart ----------
// Each row in the size grid carries data-s2t-rtp-variant-id +
// data-s2t-rtp-variant-price (decimal string, e.g. "4.75") and contains
// a stepper (− input +). The ATC button reads every row, builds an
// items[] array, and POSTs JSON to /cart/add.js. Drawer detection on
// success uses the same ladder as the Premade hero (UpCart → Kalles
// mini-cart → CustomEvent).
(function () {
  // USD-only formatter. We intentionally avoid Shopify.formatMoney here:
  // Kalles' wrapper expects a pre-divided dollar value, not cents, and
  // calling it with cents like the docs say produces "$2050.00" for a
  // $20.50 total. Intl.NumberFormat is locale-aware and consistent.
  var moneyFormatter = (function () {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return null;
    }
  })();
  function formatMoney(cents) {
    var dollars = cents / 100;
    if (moneyFormatter) return moneyFormatter.format(dollars);
    return '$' + dollars.toFixed(2);
  }

  function clampQty(value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 0) return 0;
    if (n > 99) return 99;
    return n;
  }

  function getRows(purchase) {
    return purchase.querySelectorAll('[data-s2t-rtp-row]');
  }

  function recompute(purchase) {
    var totalQty = 0;
    var totalCents = 0;
    var items = [];
    var rows = getRows(purchase);
    rows.forEach(function (row) {
      var qtyInput = row.querySelector('[data-s2t-rtp-qty]');
      if (!qtyInput) return;
      var qty = clampQty(qtyInput.value);
      if (qty === 0) return;
      // variant.price in Liquid is already in cents (integer) — don't
      // multiply by 100 again.
      var priceCents = parseInt(row.getAttribute('data-s2t-rtp-variant-price') || '0', 10) || 0;
      totalQty += qty;
      totalCents += priceCents * qty;
      items.push({
        id: row.getAttribute('data-s2t-rtp-variant-id'),
        quantity: qty
      });
    });

    var moneyStr = formatMoney(totalCents);
    var template = purchase.getAttribute('data-running-total-template') || 'Total: {qty} items · {price}';
    var rt = purchase.querySelector('[data-s2t-rtp-running-total]');
    if (rt) rt.textContent = template.replace('{qty}', totalQty).replace('{price}', moneyStr);

    // Sticky bottom ATC (mobile) — show only when total > 0.
    var sticky = document.querySelector('[data-s2t-rtp-sticky-atc]');
    if (sticky) {
      var stickyTemplate = purchase.getAttribute('data-sticky-atc-label') || 'Add {qty} items · {price}';
      var stickyLabel = sticky.querySelector('[data-s2t-rtp-sticky-atc-label]');
      if (stickyLabel) stickyLabel.textContent = stickyTemplate.replace('{qty}', totalQty).replace('{price}', moneyStr);
      if (totalQty > 0) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
    }

    // Clear inline error as soon as the customer touches a stepper.
    var errEl = purchase.querySelector('[data-s2t-rtp-error]');
    if (errEl && !errEl.hidden) {
      errEl.hidden = true;
      errEl.textContent = '';
    }

    return { items: items, totalQty: totalQty, totalCents: totalCents };
  }

  // Stepper +/− buttons (delegated).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-rtp-step]');
    if (!btn) return;
    var row = btn.closest('[data-s2t-rtp-row]');
    var purchase = btn.closest('[data-s2t-rtp-purchase]');
    if (!row || !purchase) return;
    if (row.getAttribute('data-s2t-rtp-variant-available') === 'false') return;
    var input = row.querySelector('[data-s2t-rtp-qty]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-s2t-rtp-step'), 10) || 0;
    input.value = clampQty(parseInt(input.value || '0', 10) + delta);
    recompute(purchase);
  });

  // Manual qty input — clamp on input + blur.
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-s2t-rtp-qty]');
    if (!input) return;
    var purchase = input.closest('[data-s2t-rtp-purchase]');
    if (!purchase) return;
    recompute(purchase);
  });
  document.addEventListener('blur', function (e) {
    var input = e.target.closest('[data-s2t-rtp-qty]');
    if (!input) return;
    input.value = clampQty(input.value);
    var purchase = input.closest('[data-s2t-rtp-purchase]');
    if (purchase) recompute(purchase);
  }, true);

  // ---- Mobile/tablet compact picker (one size at a time) ----
  // Choosing a size + qty and tapping "Add to Cart" writes that qty into
  // the matching (CSS-hidden) grid row, then fires the shared performAdd()
  // in 'drawer' mode — adds the item and opens the cart drawer, same as
  // desktop. (Was 'stay' mode: that suppressed UpCart's auto-open by
  // force-closing it, which flashed the drawer open-then-shut — bad UX.)

  // Compact qty stepper — the "how many of this size to add" field (min 1).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-rtp-compact-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-s2t-rtp-compact]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-s2t-rtp-compact-qty]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-s2t-rtp-compact-step'), 10) || 0;
    var next = (parseInt(input.value || '1', 10) || 1) + delta;
    if (next < 1) next = 1;
    if (next > 99) next = 99;
    input.value = next;
  });

  // "Add to Cart" — add the chosen size + qty and open the cart drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-rtp-compact-add]');
    if (!btn) return;
    var purchase = btn.closest('[data-s2t-rtp-purchase]');
    var wrap = btn.closest('[data-s2t-rtp-compact]');
    if (!purchase || !wrap) return;
    var select = wrap.querySelector('[data-s2t-rtp-compact-select]');
    var qtyInput = wrap.querySelector('[data-s2t-rtp-compact-qty]');
    if (!select || !select.value) {
      // Tapped Add to Cart without picking a size — shake the dropdown so
      // the failure point is obvious, then focus it.
      if (select) {
        var shakeClass = 's2t-product-hero-rtp__compact-select--shake';
        select.classList.remove(shakeClass);
        // Force reflow so the animation can re-trigger if they tap twice.
        void select.offsetWidth;
        select.classList.add(shakeClass);
        select.addEventListener('animationend', function onEnd() {
          select.classList.remove(shakeClass);
          select.removeEventListener('animationend', onEnd);
        });
        select.focus();
      }
      return;
    }
    var addQty = clampQty(qtyInput ? qtyInput.value : '1');
    if (addQty < 1) addQty = 1;
    var row = purchase.querySelector('[data-s2t-rtp-row][data-s2t-rtp-variant-id="' + select.value + '"]');
    if (!row || row.getAttribute('data-s2t-rtp-variant-available') === 'false') return;
    var rowInput = row.querySelector('[data-s2t-rtp-qty]');
    if (!rowInput) return;
    // Immediate-add model: all other rows are already 0 (performAdd resets
    // them on every success), so set — not accumulate — this one row, and
    // performAdd's items[] is the single chosen variant.
    rowInput.value = addQty;
    // Open the cart drawer after adding, same as desktop. UpCart's own
    // auto-open-on-add fires too; both point at the same drawer, so
    // whichever wins the race the customer just sees it open once.
    performAdd(purchase, {
      behavior: 'drawer',
      button: btn,
      onDone: function () {
        select.selectedIndex = 0;
        if (qtyInput) qtyInput.value = 1;
      }
    });
  });

  // ATC click — both the in-flow button + the mobile sticky bar trigger.
  function findPurchase(trigger) {
    var direct = trigger.closest('[data-s2t-rtp-purchase]');
    if (direct) return direct;
    // Sticky bar lives outside the purchase div on mobile — fall back to
    // the first purchase block in the same section.
    var section = trigger.closest('.s2t-product-hero-rtp');
    return section ? section.querySelector('[data-s2t-rtp-purchase]') : null;
  }

  function openDrawer(payload) {
    var opened = false;
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
    }
    if (typeof window.upcartOpenCart === 'function') {
      try { window.upcartOpenCart(); opened = true; } catch (e) {}
    }
    if (!opened && window.UpCart && typeof window.UpCart.open === 'function') {
      try { window.UpCart.open(); opened = true; } catch (e) {}
    }
    if (!opened) {
      var toggle = document.querySelector('[data-action="open-mini-cart"], .t4s-mini-cart-toggle, .t4s-mc-toggle, #mini-cart-toggle, [data-toggle="t4s-mini-cart"]');
      if (toggle) { toggle.click(); opened = true; }
    }
    if (!opened) {
      var cartLink = document.querySelector('a[href="/cart"]');
      if (cartLink && cartLink.dataset && cartLink.dataset.drawerOpen !== undefined) {
        cartLink.click();
        opened = true;
      }
    }
    if (!opened) {
      try {
        window.dispatchEvent(new CustomEvent('s2t:open-cart-drawer', {
          bubbles: true,
          detail: payload
        }));
      } catch (e) {}
    }
  }

  function showError(purchase, message) {
    var errEl = purchase.querySelector('[data-s2t-rtp-error]');
    if (!errEl) return;
    errEl.textContent = message;
    errEl.hidden = false;
    // Suppress any lingering success banner so the two don't stack.
    var successEl = purchase.querySelector('[data-s2t-rtp-success]');
    if (successEl) { successEl.hidden = true; successEl.textContent = ''; }
  }

  // Shows the green inline banner for ~2.4s. Used by performAdd in 'stay'
  // mode so the customer sees a real confirmation (the button label flash
  // alone is easy to miss with a thumb on top of it).
  function showSuccess(purchase, message, ms) {
    var el = purchase.querySelector('[data-s2t-rtp-success]');
    if (!el) return;
    // Clear any lingering error.
    var errEl = purchase.querySelector('[data-s2t-rtp-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    el.textContent = message;
    el.hidden = false;
    // Reset any pending hide-timer.
    if (el.__s2tHideTimer) clearTimeout(el.__s2tHideTimer);
    el.__s2tHideTimer = setTimeout(function () {
      el.hidden = true;
      el.textContent = '';
    }, typeof ms === 'number' ? ms : 2400);
  }

  function setAtcState(purchase, state, text) {
    var inlineBtn = purchase.querySelector('[data-s2t-rtp-atc]');
    var inlineLabel = purchase.querySelector('[data-s2t-rtp-atc-label]');
    var stickyBtn = document.querySelector('[data-s2t-rtp-sticky-atc-btn]');
    var stickyLabel = document.querySelector('[data-s2t-rtp-sticky-atc-label]');

    [inlineBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = state === 'loading';
      btn.classList.toggle('s2t-product-hero-rtp__atc-button--loading', state === 'loading');
    });
    if (text != null) {
      if (inlineLabel) inlineLabel.textContent = text;
      if (stickyLabel) stickyLabel.textContent = text;
    }
  }

  // Refresh the cart badge/count without opening the drawer — used by
  // 'stay' mode so the header count increments after each immediate add.
  // The upcart:cart-updated dispatch is what UpCart treats as a "show me"
  // signal and re-opens the drawer on. Gate it on the global suppress flag
  // so mobile compact adds don't re-trigger UpCart after we just closed it.
  function refreshCartCount() {
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
    }
    try { window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) {}
    if (window.__s2tRtpSuppressUpcart !== true) {
      try { window.dispatchEvent(new CustomEvent('upcart:cart-updated', { bubbles: true })); } catch (e) {}
    }
  }

  // Shared add-to-cart. opts.behavior overrides the section's
  // data-cart-behavior ('drawer' | 'stay' | 'cart_page'); opts.button is
  // the compact "Add to Cart" trigger (so its label cycles too); opts.onDone
  // fires on success (used by the compact picker to reset the dropdown).
  function performAdd(purchase, opts) {
    opts = opts || {};
    var snapshot = recompute(purchase);
    if (snapshot.totalQty === 0) {
      showError(purchase, purchase.getAttribute('data-empty-message') || 'Pick at least one size to add to cart.');
      return;
    }

    var defaultLabel = purchase.getAttribute('data-label-default') || 'Add to Cart';
    var addingLabel = purchase.getAttribute('data-label-adding') || 'Adding…';
    var addedLabel = purchase.getAttribute('data-label-added') || 'Added ✓';
    var errorMessage = purchase.getAttribute('data-error-message') || 'Sorry, we couldn’t add this to your cart. Please try again.';
    var behavior = opts.behavior || purchase.getAttribute('data-cart-behavior') || 'drawer';

    // Compact trigger button keeps its own default label (the configured
    // "Add to Cart"); cycle it through Adding… / Added ✓ / default too.
    var cBtn = opts.button || null;
    var cLabelEl = cBtn ? cBtn.querySelector('[data-s2t-rtp-compact-add-label]') : null;
    var cDefault = cLabelEl ? cLabelEl.textContent.trim() : defaultLabel;
    function setCompactState(state, text) {
      if (!cBtn) return;
      cBtn.disabled = state === 'loading';
      if (text != null && cLabelEl) cLabelEl.textContent = text;
    }

    setAtcState(purchase, 'loading', addingLabel);
    setCompactState('loading', addingLabel);

    // Merge per-call line-item properties into every item in the payload.
    // Used by the mobile compact handler to bake in _skip_upcart_open so
    // UpCart's "Open cart on add" trigger ignores this request. Underscore
    // prefix = hidden from the customer-facing cart UI per Shopify convention.
    var payloadItems = snapshot.items;
    if (opts.extraProperties && typeof opts.extraProperties === 'object') {
      payloadItems = snapshot.items.map(function (item) {
        var merged = { id: item.id, quantity: item.quantity };
        merged.properties = Object.assign({}, item.properties || {}, opts.extraProperties);
        return merged;
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: payloadItems })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var msg = (data && data.description) || (data && data.message) || errorMessage;
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function (data) {
        // Defensive UpCart-close: even with _skip_upcart_open and the global
        // suppress flag, some UpCart builds still pop the drawer in the gap
        // between our fetch and this success handler. If suppressDrawer is
        // on, force-close UpCart here. No-op when UpCart isn't installed or
        // its drawer isn't open.
        if (opts.suppressDrawer) {
          var closeDrawer = function () {
            try { if (typeof window.upcartCloseCart === 'function') window.upcartCloseCart(); } catch (e) {}
            try { if (window.UpCart && typeof window.UpCart.close === 'function') window.UpCart.close(); } catch (e) {}
          };
          // Immediate close, then keep closing every 50ms for ~800ms to
          // cover UpCart's debounced re-open window (typically 200-700ms
          // after its /cart/add.js network listener fires).
          closeDrawer();
          var closeLoop = setInterval(closeDrawer, 50);
          setTimeout(function () { clearInterval(closeLoop); }, 800);
        }

        // Reset steppers + recompute (clears running total).
        getRows(purchase).forEach(function (row) {
          var qtyInput = row.querySelector('[data-s2t-rtp-qty]');
          if (qtyInput) qtyInput.value = 0;
        });
        recompute(purchase);

        // Notify the cart-progress indicator.
        try {
          window.dispatchEvent(new CustomEvent('s2t:rtp-cart-updated', { bubbles: true, detail: data }));
        } catch (e) {}

        function revert() {
          setAtcState(purchase, 'idle', defaultLabel);
          setCompactState('idle', cDefault);
        }

        if (behavior === 'cart_page') {
          window.location.href = '/cart';
          return;
        }
        if (behavior === 'stay') {
          // Update the header cart count, but don't open the drawer — the
          // customer stays on the picker to add the next size.
          refreshCartCount();
          // Inline green success banner — the button label flash alone is
          // easy to miss on mobile (thumb covers the button).
          var successMessage = purchase.getAttribute('data-success-message') || 'Added to cart — keep shopping';
          showSuccess(purchase, successMessage);
          setAtcState(purchase, 'idle', addedLabel);
          setCompactState('idle', addedLabel);
          setTimeout(revert, 1500);
          if (typeof opts.onDone === 'function') opts.onDone();
          return;
        }

        openDrawer(data);
        setAtcState(purchase, 'idle', addedLabel);
        setCompactState('idle', addedLabel);
        setTimeout(revert, 1500);
        if (typeof opts.onDone === 'function') opts.onDone();
      })
      .catch(function (err) {
        console.error('[s2t-product-hero-rtp] Add to cart failed:', err);
        setAtcState(purchase, 'idle', defaultLabel);
        setCompactState('idle', cDefault);
        showError(purchase, (err && err.message) ? err.message : errorMessage);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-rtp-atc], [data-s2t-rtp-sticky-atc-btn]');
    if (!btn) return;
    var purchase = findPurchase(btn);
    if (!purchase) return;
    e.preventDefault();
    performAdd(purchase);
  });

  // Initial paint — running total starts at "0 items · $0.00" already
  // server-rendered. Run recompute once on load so it picks up any
  // pre-filled steppers (none today, but harmless and forward-compat).
  function initAll() {
    document.querySelectorAll('[data-s2t-rtp-purchase]').forEach(recompute);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

// ---------- Cart-progress indicator for Buy 3 Get 1 Free ----------
// Reads /cart.js, counts items whose product carries the 'rtp' tag,
// and paints one of four messages (0 / 1 / 2 / ≥ threshold).
//
// Tag check: /cart.js doesn't expose product tags, so for each unique
// handle in the cart we lazy-fetch /products/{handle}.js once per
// session (cached in sessionStorage). Typical cart has 1–6 unique
// products → cheap, cached after first hit.
//
// Refresh triggers: own s2t:rtp-cart-updated (dispatched on ATC),
// generic cart:updated (Sections API + some themes), upcart:cart-updated,
// pageshow (bfcache return), visibilitychange → visible (tab return).
(function () {
  var TAG_NAME = 'rtp';
  var SESSION_KEY = 's2t:rtp-tag-cache';
  var tagCache = {};
  try {
    var stored = window.sessionStorage.getItem(SESSION_KEY);
    if (stored) tagCache = JSON.parse(stored) || {};
  } catch (e) {}

  function persistCache() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(tagCache));
    } catch (e) {}
  }

  function fetchHandleTags(handle) {
    if (tagCache[handle] !== undefined) {
      return Promise.resolve(tagCache[handle]);
    }
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var hasTag = !!(data && data.tags && data.tags.indexOf(TAG_NAME) !== -1);
        tagCache[handle] = hasTag;
        persistCache();
        return hasTag;
      })
      .catch(function () {
        tagCache[handle] = false;
        return false;
      });
  }

  function substitute(template, subs) {
    if (!template) return '';
    return template
      .replace(/\{count\}/g, subs.count != null ? subs.count : '')
      .replace(/\{threshold\}/g, subs.threshold != null ? subs.threshold : '')
      .replace(/\{in_cycle\}/g, subs.in_cycle != null ? subs.in_cycle : '')
      .replace(/\{to_qualify\}/g, subs.to_qualify != null ? subs.to_qualify : '')
      .replace(/\{claimed\}/g, subs.claimed != null ? subs.claimed : '')
      .replace(/\{plural\}/g, subs.plural != null ? subs.plural : '');
  }

  function paintAll(count) {
    document.querySelectorAll('[data-s2t-rtp-progress]').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 3;
      var textEl = el.querySelector('[data-s2t-rtp-progress-text]');
      if (!textEl) return;

      // BOGO cycle length = threshold + 1 (e.g. "buy 3 get 1 free" = 4-item cycle).
      // The first `threshold` items of each cycle are paid; the next item is the
      // free one that gets auto-discounted at checkout. So:
      //   - claimed   = freebies the customer has already added to cart
      //   - in_cycle  = position within the current cycle (0..threshold)
      //   - to_qualify = items still needed to qualify for the NEXT free transfer
      var cycleLen = threshold + 1;
      var claimed = Math.floor(count / cycleLen);
      var inCycle = count % cycleLen;
      var toQualify = threshold - inCycle;
      if (toQualify < 0) toQualify = 0;
      var plural = claimed === 1 ? '' : 's';
      var subs = {
        count: count,
        threshold: threshold,
        in_cycle: inCycle,
        to_qualify: toQualify,
        claimed: claimed,
        plural: plural
      };

      var template;
      if (count === 0) {
        template = el.getAttribute('data-msg-0');
      } else if (inCycle === threshold) {
        // Qualified — the customer has paid for `threshold` items in the
        // current cycle but hasn't added the free one yet.
        template = el.getAttribute('data-msg-qualified');
      } else if (claimed === 0) {
        // First cycle, working toward qualifying.
        template = (inCycle === threshold - 1)
          ? el.getAttribute('data-msg-close')
          : el.getAttribute('data-msg-mid');
      } else {
        // Already claimed ≥1 free; mid-stacked-cycle (inCycle 0..threshold-1).
        template = el.getAttribute('data-msg-stacked');
      }

      textEl.textContent = substitute(template, subs);
      // Green "earned" styling applies once the customer has either claimed
      // any freebie OR just qualified for one.
      el.classList.toggle(
        's2t-product-hero-rtp__progress--met',
        claimed > 0 || inCycle === threshold
      );
      el.setAttribute('data-rtp-count', count);
      el.setAttribute('data-rtp-claimed', claimed);
    });
  }

  var loadInFlight = null;
  function loadCart() {
    if (loadInFlight) return loadInFlight;
    loadInFlight = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : { items: [] }; })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        // Group quantities by handle.
        var qtyByHandle = {};
        items.forEach(function (item) {
          var h = item.handle;
          if (!h) return;
          qtyByHandle[h] = (qtyByHandle[h] || 0) + (item.quantity || 0);
        });
        var handles = Object.keys(qtyByHandle);
        if (handles.length === 0) return paintAll(0);
        return Promise.all(handles.map(fetchHandleTags)).then(function (flags) {
          var rtpCount = 0;
          handles.forEach(function (h, i) {
            if (flags[i]) rtpCount += qtyByHandle[h];
          });
          paintAll(rtpCount);
        });
      })
      .catch(function () { paintAll(0); })
      .then(function () { loadInFlight = null; });
    return loadInFlight;
  }

  // Initial paint.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCart);
  } else {
    loadCart();
  }

  // Refresh on our own ATC + on generic cart events + on tab return.
  window.addEventListener('s2t:rtp-cart-updated', function () { loadCart(); });
  window.addEventListener('cart:updated', function () { loadCart(); });
  window.addEventListener('upcart:cart-updated', function () { loadCart(); });
  window.addEventListener('pageshow', function () { loadCart(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') loadCart();
  });
})();

// ============================================================
// Rating widget — product vs. shop fallback
// ============================================================
// Judge.me injects HTML into `.jdgm-preview-badge` even for products
// with 0 reviews — and hides it via its own CSS — which broke the
// CSS-only `:empty` fallback toggle. Instead, watch the preview
// badge with a MutationObserver and read its `data-number-of-reviews`
// attribute (the reliable signal Judge.me sets on its rendered output).
// When > 0 we add the modifier class that shows the per-product badge
// and hides the shop-wide fallback widget.
(function () {
  var WATCH_MS = 12000;

  function getReviewCount(badgeContainer) {
    if (!badgeContainer) return 0;
    var candidates = [badgeContainer].concat(
      Array.prototype.slice.call(
        badgeContainer.querySelectorAll('[data-number-of-reviews]')
      )
    );
    var max = 0;
    for (var i = 0; i < candidates.length; i++) {
      var v = candidates[i].getAttribute && candidates[i].getAttribute('data-number-of-reviews');
      if (v == null) continue;
      var n = parseInt(v, 10);
      if (!isNaN(n) && n > max) max = n;
    }
    return max;
  }

  function evaluate(wrapper) {
    var badge = wrapper.querySelector('.jdgm-preview-badge');
    if (getReviewCount(badge) > 0) {
      wrapper.classList.add('s2t-product-hero-rtp__rating--has-product-reviews');
      return true;
    }
    return false;
  }

  function initOne(wrapper) {
    if (evaluate(wrapper)) return;
    var badge = wrapper.querySelector('.jdgm-preview-badge');
    if (!badge || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (evaluate(wrapper)) observer.disconnect();
    });
    observer.observe(badge, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews']
    });

    setTimeout(function () { observer.disconnect(); }, WATCH_MS);
  }

  function initAll() {
    document.querySelectorAll('[data-s2t-rating]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

// ============================================================
// Shop Reviews modal
// ============================================================
// Clicking the shop-reviews fallback button opens this modal instead
// of navigating away. Inside it: Judge.me's `jdgm-all-reviews-widget`,
// which renders the full shop review list with their own filter +
// pagination UI. On first open we nudge Judge.me to (re-)scan + load
// the widget in case it skipped it on initial page load (some Judge.me
// versions skip widgets inside hidden containers).
//
// The modal is portaled to <body> on open to escape any local stacking
// context, same pattern as the FBT quick-view modal in s2t-products.
(function () {
  function portalToBody(modal) {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function openModal(modal, trigger) {
    portalToBody(modal);
    modal._s2tLastTrigger = trigger || null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('s2t-rv-open');

    var closeBtn = modal.querySelector('[data-s2t-reviews-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('s2t-rv-open');
    var lastTrigger = modal._s2tLastTrigger;
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // Cache modal reference on the section element so it survives the
  // portal-to-body move (the modal leaves the section's DOM subtree
  // on first open).
  function findModalForTrigger(trigger) {
    var section = trigger.closest('.s2t-product-hero-rtp');
    if (!section) return null;
    var modal = section._s2tReviewsModal || section.querySelector('[data-s2t-reviews-modal]');
    if (modal) section._s2tReviewsModal = modal;
    return modal;
  }

  // Open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-s2t-reviews-open]');
    if (!trigger) return;
    var modal = findModalForTrigger(trigger);
    if (!modal) return;
    e.preventDefault();
    openModal(modal, trigger);
  });

  // Close — overlay or close button
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-s2t-reviews-close]');
    if (!closer) return;
    var modal = closer.closest('[data-s2t-reviews-modal]');
    closeModal(modal);
  });

  // Close — Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-s2t-reviews-modal]:not([hidden])').forEach(closeModal);
  });
})();